export default __webpack_public_path__ + "a0810de33a778db89ba9234cef49f5f1.png";